import type { OcsPatchEntryInput, WriteOcsSettingsResult } from 'owa-graph-schema';
import { lazyWriteOcsSettings } from 'owa-ocs-service-gql';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getAccountScopeUserSettings } from 'owa-session-store';

export default async function saveOcsPersonaCheckboxDisplaySetting(
    personaCheckboxDisplay: number
): Promise<WriteOcsSettingsResult | undefined> {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    const ocsPersonaCheckboxDisplayPatch: OcsPatchEntryInput = {
        name: 'mail_personacheckboxdisplay',
        value: personaCheckboxDisplay.toString(),
        type: 'INT',
        scope: getAccountScopeUserSettings(mailboxInfo).SessionSettings?.UserEmailAddress || '',
        itemClass: 'RoamingSetting',
    };

    return lazyWriteOcsSettings.importAndExecute(
        mailboxInfo,
        'ACCOUNT',
        [ocsPersonaCheckboxDisplayPatch],
        'setPersonaCheckboxDisplay' /* actionName */
    );
}
